import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ValidatedTextInput } from '@els/els-react--text-input';
import {
  ALERT_NAME_MIN_LENGTH,
  ALERT_NAME_MAX_LENGTH,
  getAlertNameMinLengthValidationMessage,
  getAlertNameMaxLengthValidationMessage,
} from '../AlertCreateDialogConstatns';
import './AlertNameRow.scss';

function AlertNameRow({ alertFormAlertName, setAlertFormAlertName, validateAlertName }) {
  const getValidationResult = useCallback((value) => (validateAlertName ? validateAlertName(value) : true), [validateAlertName]);

  const handleChange = useCallback(
    (valueOrEvent) => {
      const validationResult = getValidationResult(valueOrEvent);
      const isValid = validationResult !== false;
      if (isValid) {
        setAlertFormAlertName(valueOrEvent);
      }
    },
    [getValidationResult, setAlertFormAlertName]
  );

  const resolveAlertNameError = useCallback(
    (valueOrEvent) => {
      const currentValue = valueOrEvent || alertFormAlertName;

      if (currentValue?.length > 0 && currentValue.length < ALERT_NAME_MIN_LENGTH) {
        return getAlertNameMinLengthValidationMessage();
      }

      if (currentValue?.length > ALERT_NAME_MAX_LENGTH) {
        return getAlertNameMaxLengthValidationMessage();
      }

      const validationResult = getValidationResult(currentValue);

      if (validationResult && typeof validationResult === 'object' && !validationResult.isValid) {
        return validationResult.validationMessage;
      }

      return validationResult === false ? 'Invalid alert name' : null;
    },
    [getValidationResult, alertFormAlertName]
  );

  const placeholderText = alertFormAlertName ? 'Name' : 'Choose a name';
  const validationMessage = resolveAlertNameError(alertFormAlertName);

  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-name">
      <div className="create-alert-dialog-column-label">Alert name:</div>
      <div className="create-alert-dialog-column-content">
        <ValidatedTextInput
          data-e2e="alert-name-input"
          className="create-alert-name create-alert-name-input"
          label="Name"
          min={ALERT_NAME_MIN_LENGTH}
          max={ALERT_NAME_MAX_LENGTH}
          onChange={(event) => {
            handleChange(event.target?.value);
          }}
          value={alertFormAlertName}
          placeholder={placeholderText}
          validator={resolveAlertNameError}
          required
        />
        <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
          {validationMessage || ''}
        </div>
      </div>
    </div>
  );
}

AlertNameRow.propTypes = {
  alertFormAlertName: PropTypes.string,
  setAlertFormAlertName: PropTypes.func.isRequired,
  validateAlertName: PropTypes.func.isRequired,
};

export default AlertNameRow;
